enum IconTypes {
    APPLE_PAY_24 = 'apple-pay-24',
    APPLE_PAY_36 = 'apple-pay-36',
    APPLE_PAY_DYN = 'apple-pay',
    /** @deprecated ATTACHMENT_24 */
    ATTACHMENT_24 = 'attachment-24',
    /** @deprecated ATTACHMENT_36 */
    ATTACHMENT_36 = 'attachment-36',
    ATV_24 = 'atv-24',
    ATV_36 = 'atv-36',
    BANK_24 = 'bank-24',
    BANK_36 = 'bank-36',
    BANK_ID_BRIKKE_24 = 'bank-id-brikke-24',
    BANK_ID_BRIKKE_36 = 'bank-id-brikke-36',
    BANK_ID_PA_MOBIL_24 = 'bank-id-pa-mobil-24',
    BANK_ID_PA_MOBIL_36 = 'bank-id-pa-mobil-36',
    BANKKORT_24 = 'bankkort-24',
    BANKKORT_36 = 'bankkort-36',
    BARN_24 = 'barn-24',
    BARN_36 = 'barn-36',
    BAT_24 = 'bat-24',
    BAT_36 = 'bat-36',
    BEDRIFT_24 = 'bedrift-24',
    BEDRIFT_36 = 'bedrift-36',
    BETALE_24 = 'betale-24',
    BETALE_36 = 'betale-36',
    BEVEGELSER_24 = 'bevegelser-24',
    BEVEGELSER_36 = 'bevegelser-36',
    BIL_24 = 'bil-24',
    BIL_36 = 'bil-36',
    BIL_2_24 = 'bil-2-24',
    BIL_2_36 = 'bil-2-36',
    BIL_2_DYN = 'bil-2',
    BIOMETRI_24 = 'biometri-24',
    BIOMETRI_36 = 'biometri-36',
    BIOMETRI_DYN = 'biometri',
    BLAD_24 = 'blad-24',
    BLAD_36 = 'blad-36',
    BOBIL_24 = 'bobil-24',
    BOBIL_36 = 'bobil-36',
    BONDEGARD_24 = 'bondegard-24',
    BONDEGARD_36 = 'bondegard-36',
    /** @deprecated BUET_PIL_HOEYRE_20 */
    BUET_PIL_HOEYRE_20 = 'buet-pil-hoeyre-20',
    BUTIKK_24 = 'butikk-24',
    BUTIKK_36 = 'butikk-36',
    BYGGELAN_24 = 'byggelan-24',
    BYGGELAN_36 = 'byggelan-36',
    CAMPING_24 = 'camping-24',
    CAMPING_36 = 'camping-36',
    CHAT_24 = 'chat-24',
    CHAT_36 = 'chat-36',
    /** @deprecated CHECKED_24 */
    CHECKED_24 = 'checked-24',
    CHECKMARK_LISTE_24 = 'checkmark-liste-24',
    CHECKMARK_TIL_BOKS_24 = 'checkmark-til-boks-24',
    CHECKMARK_TIL_SIRKEL_24 = 'checkmark-til-sirkel-24',
    CHECKMARK_TIL_SIRKEL_36 = 'checkmark-til-sirkel-36',
    COPY_24 = 'copy-24',
    COPY_36 = 'copy-36',
    DODSFALL_24 = 'dodsfall-24',
    DODSFALL_36 = 'dodsfall-36',
    DOKUMENT_24 = 'dokument-24',
    DOKUMENT_36 = 'dokument-36',
    DRAG_N_DROP_24 = 'drag-n-drop-24',
    DRONE_24 = 'drone-24',
    DRONE_36 = 'drone-36',
    DRONE_DYN = 'drone',
    E_FAKTURA_24 = 'e-faktura-24',
    /** @deprecated use E_FAKTURA_24 */
    E_FAKTURA_24_1 = 'e-faktura-24_1',
    E_FAKTURA_36 = 'e-faktura-36',
    E_FAKTURA_LOGO_24 = 'e-faktura-logo-24',
    E_FAKTURA_LOGO_36 = 'e-faktura-logo-36',
    EKSTERN_24 = 'ekstern-24',
    /** @deprecated EKSTERN_36 */
    EKSTERN_36 = 'ekstern-36',
    ELSPAREKSYKKEL_24 = 'elsparkesykkel-24',
    ELSPAREKSYKKEL_36 = 'elsparkesykkel-36',
    ELSPARKESYKKEL_DYN = 'elsparkesykkel',
    /** @deprecated use faste-betalinger-36 */
    FAST_BETALING_36 = 'fast-betaling-36',
    /** @deprecated FAST_OVERFOR_36 */
    FAST_OVERFOR_36 = 'fast-overfor-36',
    FAKTURA_24 = 'faktura-24',
    FAKTURA_36 = 'faktura-36',
    FAMILIE_24 = 'familie-24',
    FAMILIE_36 = 'familie-36',
    FASTE_BETALINGER_24 = 'faste-betalinger-24',
    FASTE_BETALINGER_36 = 'faste-betalinger-36',
    FASTE_BETALINGER_DYN = 'faste-betalinger',
    FORDELER_24 = 'fordeler-24',
    FORDELER_36 = 'fordeler-36',
    FORSIKRINGSBEVIS_REISE_24 = 'forsikringsbevis-reise-24',
    FORSIKRINGSBEVIS_REISE_36 = 'forsikringsbevis-reise-36',
    GAVE_24 = 'gave-24',
    GAVE_36 = 'gave-36',
    GOOGLE_PAY_24 = 'google-pay-24',
    GOOGLE_PAY_36 = 'google-pay-36',
    GOOGLE_PAY_DYN = 'google-pay',
    GRAFLINJE_24 = 'graflinje-24',
    GRAFLINJE_36 = 'graflinje-36',
    GRAVEMASKIN_24 = 'gravemaskin-24',
    GRAVEMASKIN_36 = 'gravemaskin-36',
    GRUPPE_24 = 'gruppe-24',
    GRUPPE_36 = 'gruppe-36',
    HAMBURGER = 'hamburger',
    HANDLEKURV_24 = 'handlekurv-24',
    HANDLEKURV_36 = 'handlekurv-36',
    HANDTRYKK_24 = 'handtrykk-24',
    HANDTRYKK_36 = 'handtrykk-36',
    HANDTVERKER__BIL_36 = 'handtverker--bil-36',
    // @deprecate use HANDTVERKER__BIL_36 instead
    HANDTVERKER__BIL_36_2 = 'handtverker--bil-36_2',
    HANDTVERKER_BIL_24 = 'handtverker-bil-24',
    HANDVERKER_24 = 'handverker-24',
    HANDVERKER_36 = 'handverker-36',
    HELSE_24 = 'helse-24',
    HELSE_36 = 'helse-36',
    HENGELAS_APEN_24 = 'hengelas-apen-24',
    HENGELAS_APEN_36 = 'hengelas-apen-36',
    HEST_24 = 'hest-24',
    HEST_36 = 'hest-36',
    HONE_24 = 'hone-24',
    HONE_36 = 'hone-36',
    HUND_24 = 'hund-24',
    HUND_36 = 'hund-36',
    HUS_24 = 'hus-24',
    HUS_36 = 'hus-36',
    HYTTE_24 = 'hytte-24',
    HYTTE_36 = 'hytte-36',
    INBOX_24 = 'inbox-24',
    INBOX_36 = 'inbox-36',
    INFO_20 = 'info-20',
    INFO_24 = 'info-24',
    INFO_36 = 'info-36',
    INNBOFORSIKRING_24 = 'innboforsikring-24',
    INNBOFORSIKRING_36 = 'innboforsikring-36',
    INNFRI_KREDITTKORT_24 = 'innfri-kredittkort-24',
    INNFRI_KREDITTKORT_36 = 'innfri-kredittkort-36',
    INNSTILLINGER_24 = 'innstillinger-24',
    INNSTILLINGER_36 = 'innstillinger-36',
    INNTEKT_24 = 'inntekt-24',
    INNTEKT_36 = 'inntekt-36',
    JORDEN_24 = 'jorden-24',
    JORDEN_36 = 'jorden-36',
    KAKEDIAGRAM_24 = 'kakediagram-24',
    KAKEDIAGRAM_36 = 'kakediagram-36',
    KALENDER_20 = 'kalender-20',
    KALENDER_24 = 'kalender-24',
    KALENDER_36 = 'kalender-36',
    KALKULATOR_24 = 'kalkulator-24',
    KALKULATOR_36 = 'kalkulator-36',
    KAMERA_24 = 'kamera-24',
    KAMERA_36 = 'kamera-36',
    KART_24 = 'kart-24',
    KART_36 = 'kart-36',
    KATT_24 = 'katt-24',
    KATT_36 = 'katt-36',
    KATT_DYN = 'katt',
    KJORETOY_24 = 'kjoretoy-24',
    KJORETOY_36 = 'kjoretoy-36',
    KLOKKE_24 = 'klokke-24',
    KLOKKE_36 = 'klokke-36',
    KONTOER_24 = 'kontoer-24',
    KONTOER_36 = 'kontoer-36',
    KONTOR_24 = 'kontor-24',
    KONTOR_36 = 'kontor-36',
    KREDITTGRENSE_24 = 'kredittgrense-24',
    KREDITTGRENSE_36 = 'kredittgrense-36',
    KRYSS_24 = 'kryss-24',
    KRYSS_36 = 'kryss-36',
    KU_24 = 'ku-24',
    KU_36 = 'ku-36',
    LAN_24 = 'lan-24',
    LAN_36 = 'lan-36',
    LASTEBIL_24 = 'lastebil-24',
    LASTEBIL_36 = 'lastebil-36',
    LEGE_24 = 'lege-24',
    LEGE_36 = 'lege-36',
    LITEN_PIL_HOEYRE = 'liten-pil-hoeyre',
    /** @deprecated LITEN_PIL_HOEYRE_1 */
    LITEN_PIL_HOEYRE_1 = 'liten-pil-hoeyre_1',
    LITEN_PIL_NED = 'liten-pil-ned',
    LITEN_PIL_OPP = 'liten-pil-opp',
    LITEN_PIL_VENSTRE = 'liten-pil-venstre',
    LOMMEBOK_24 = 'lommebok-24',
    LOMMEBOK_36 = 'lommebok-36',
    LUKK_24 = 'lukk-24',
    LYSPAERE_24 = 'lyspaere-24',
    LYSPAERE_36 = 'lyspaere-36',
    MAIL_24 = 'mail-24',
    MAIL_36 = 'mail-36',
    MASTERCARD_24 = 'mastercard-24',
    MASTERCARD_36 = 'mastercard-36',
    MEDALJE_24 = 'medalje-24',
    MEDALJE_36 = 'medalje-36',
    MENY_24 = 'meny-24',
    MENY_36 = 'meny-36',
    MER_24 = 'mer-24',
    MER_36 = 'mer-36',
    MINIMER_24 = 'minimer-24',
    MINUS_24 = 'minus-24',
    MINUS_36 = 'minus-36',
    MOBIL_24 = 'mobil-24',
    MOBIL_36 = 'mobil-36',
    MOBILBANK_24 = 'mobilbank-24',
    MOBILBANK_36 = 'mobilbank-36',
    MOPED_24 = 'moped-24',
    MOPED_36 = 'moped-36',
    MOTORSYKKEL_24 = 'motorsykkel-24',
    MOTORSYKKEL_36 = 'motorsykkel-36',
    NEDLASTING_24 = 'nedlasting-24',
    NEDLASTING_36 = 'nedlasting-36',
    NETTBANK_24 = 'nettbank-24',
    NETTBANK_36 = 'nettbank-36',
    NOKKEL_24 = 'nokkel-24',
    NOKKEL_36 = 'nokkel-36',
    NYHETER_24 = 'nyheter-24',
    NYHETER_36 = 'nyheter-36',
    OVERFOERE_24 = 'overfoere-24',
    OVERFOERE_36 = 'overfoere-36',
    OYE_24 = 'oye-24',
    OYE_36 = 'oye-36',
    PALME_24 = 'palme-24',
    PALME_36 = 'palme-36',
    PALME_DYN = 'palme',
    PARAPLY_24 = 'paraply-24',
    PARAPLY_36 = 'paraply-36',
    PENGESEKK_24 = 'pengesekk-24',
    PENGESEKK_36 = 'pengesekk-36',
    PENN_24 = 'penn-24',
    PENN_36 = 'penn-36',
    // @deprecated use palme-36
    PENSJON_36 = 'pensjon-36',
    PERSONER_24 = 'personer-24',
    PERSONER_36 = 'personer-36',
    PIL_DROPDOWN_OPP_24 = 'pil-dropdown-opp-24',
    PIL_DROPDOWN_NED_24 = 'pil-dropdown-ned-24',
    PIL_HOEYRE = 'pil-hoeyre',
    PIL_NED = 'pil-ned',
    PIL_OPP = 'pil-opp',
    PIL_VENSTRE = 'pil-venstre',
    PIL_STOR_HOEYRE_24 = 'pil-stor-hoeyre-24',
    PIL_STOR_NED_24 = 'pil-stor-ned-24',
    PIL_STOR_OPP_24 = 'pil-stor-opp-24',
    PIL_STOR_VENSTRE_24 = 'pil-stor-venstre-24',
    PIN_KODE_24 = 'pin-kode-24',
    PIN_KODE_36 = 'pin-kode-36',
    PLANTE_24 = 'plante-24',
    PLANTE_36 = 'plante-36',
    PLASTER_24 = 'plaster-24',
    PLASTER_36 = 'plaster-36',
    PLUSS_24 = 'pluss-24',
    PLUSS_36 = 'pluss-36',
    PRINT_24 = 'print-24',
    PRINT_36 = 'print-36',
    PRIS_PIL_36 = 'pris-pil-36',
    PROFIL_24 = 'profil-24',
    PROFIL_36 = 'profil-36',
    PROFIL_I_SIRKEL_24 = 'profil-i-sirkel-24',
    RADGIVER_24 = 'radgiver-24',
    RADGIVER_36 = 'radgiver-36',
    RADGIVING_24 = 'radgiving-24',
    RADGIVING_36 = 'radgiving-36',
    REFINANSIERING_24 = 'refinansiering-24',
    REFINANSIERING_36 = 'refinansiering-36',
    REGIONSPERRE_24 = 'regionsperre-24',
    REGIONSPERRE_36 = 'regionsperre-36',
    RENTER_24 = 'renter-24',
    RENTER_36 = 'renter-36',
    RESIRKULER_24 = 'resirkuler-24',
    RESIRKULER_36 = 'resirkuler-36',
    SAMSUNG_WALLET_24 = 'samsung-wallet-24',
    SAMSUNG_WALLET_36 = 'samsung-wallet-36',
    SAMSUNG_WALLET_DYN = 'samsung-wallet',
    SIGNATUR_24 = 'signatur-24',
    SIGNATUR_36 = 'signatur-36',
    SIKKERHET_24 = 'sikkerhet-24',
    SIKKERHET_36 = 'sikkerhet-36',
    SKADE_24 = 'skade-24',
    SKADE_36 = 'skade-36',
    SLETT_24 = 'slett-24',
    SLETT_36 = 'slett-36',
    SNAPCASH_24 = 'snapcash-24',
    SNAPCASH_36 = 'snapcash-36',
    SNOSCOOTER_24 = 'snoscooter-24',
    SNOSCOOTER_36 = 'snoscooter-36',
    SOEK_24 = 'soek-24',
    SOEK_36 = 'soek-36',
    SPAREGRIS_24 = 'sparegris-24',
    SPAREGRIS_36 = 'sparegris-36',
    SPARING_24 = 'sparing-24',
    SPARING_36 = 'sparing-36',
    SPERR_KORT_24 = 'sperr-kort-24',
    SPERR_KORT_36 = 'sperr-kort-36',
    // @deprecated use SPOERSMAALSTEGN_24
    SPOERSMAAL_24 = 'spoersmaal-24',
    SPOERSMAALSTEGN_24 = 'spoersmaalstegn-24',
    SPOERSMAALSTEGN_36 = 'spoersmaalstegn-36',
    SPOERSMAALSTEGN_DYN = 'spoersmaalstegn',
    STJERNE_24 = 'stjerne-24',
    STJERNE_36 = 'stjerne-36',
    STJERNEDRYSS_24 = 'stjernedryss-24',
    STJERNEDRYSS_36 = 'stjernedryss-36',
    STJERNEDRYSS_DYN = 'stjernedryss',
    STOPP_24 = 'stopp-24',
    STOPP_36 = 'stopp-36',
    TANNHJUL_24 = 'tannhjul-24',
    TANNHJUL_36 = 'tannhjul-36',
    TAXI_24 = 'taxi-24',
    TAXI_36 = 'taxi-36',
    TELEFON_24 = 'telefon-24',
    TELEFON_36 = 'telefon-36',
    TILHENGER_24 = 'tilhenger-24',
    TILHENGER_36 = 'tilhenger-36',
    TIMEGLASS_24 = 'timeglass-24',
    TIMEGLASS_36 = 'timeglass-36',
    TOMMEL_OPP_24 = 'tommel-opp-24',
    TOMMEL_OPP_36 = 'tommel-opp-36',
    TOMMEL_OPP_DYN = 'tommel-opp',
    TRAKTOR_24 = 'traktor-24',
    TRAKTOR_36 = 'traktor-36',
    TREKANT_KRYSS_24 = 'trekant-kryss-24',
    TREKANT_KRYSS_36 = 'trekant-kryss-36',
    UFOR_24 = 'ufor-24',
    UFOR_36 = 'ufor-36',
    ULYKKE_24 = 'ulykke-24',
    ULYKKE_36 = 'ulykke-36',
    /** @deprecated UNCHECKED_24 */
    UNCHECKED_24 = 'unchecked-24',
    UNG_24 = 'ung-24',
    UNG_36 = 'ung-36',
    USP_CHECKMARK_24 = 'usp-checkmark-24',
    USP_CHECKMARK_36 = 'usp-checkmark-36',
    UTROPSTEGN_24 = 'utropstegn-24',
    UTROPSTEGN_36 = 'utropstegn-36',
    VARETRANSPORT_24 = 'varetransport-24',
    VARETRANSPORT_36 = 'varetransport-36',
    VARSLER_24 = 'varsler-24',
    VARSLER_36 = 'varsler-36',
    VEKST_24 = 'vekst-24',
    VEKST_36 = 'vekst-36',
    /** @deprecated VEKT_24 */
    VEKT_24 = 'vekt-24',
    VEKT_24_2 = 'vekt-24_2',
    VEKT_36 = 'vekt-36',
    VERDI_24 = 'verdi-24',
    VERDI_36 = 'verdi-36',
    VETERANBIL_24 = 'veteranbil-24',
    /** @deprecated VETERANBIL_36 */
    VETERANBIL_36 = 'veteranbil-36',
    VIPPS_24 = 'vipps-24',
    VIPPS_36 = 'vipps-36',
    VIPPS_DYN = 'vipps',
    BACK = 'back',
    BANDAGED_HEART = 'bandaged-heart',
    CALENDAR_20 = 'calendar-20',
    CALENDAR_24 = 'calendar-24',
    CALENDAR_36 = 'calendar-36',
    SPEECH_BUBBLE_HAPPY = 'speech-bubble-happy',
    SPEECH_BUBBLE_SAD = 'speech-bubble-sad',
    SPEECH_BUBBLE_TALKING = 'speech-bubble-talking',
    WALLET_QUESTIONMARK = 'wallet-questionmark',
    WAVING_HAND = 'waving-hand',
    HEART = 'heart',
    ExternalLink = 'external-link',
    FRAMED_PROFILE_22 = 'framed-profile-22',
    FRAMED_PROFILE_24 = 'framed-profile-24',
    ATTACHMENT_DYN = 'attachment',
    ATV_DYN = 'atv',
    BANK_DYN = 'bank',
    BANK_ID_BRIKKE_DYN = 'bank-id-brikke',
    BANK_ID_PA_MOBIL_DYN = 'bank-id-pa-mobil',
    BANKKORT_DYN = 'bankkort',
    BARN_DYN = 'barn',
    BAT_DYN = 'bat',
    BEDRIFT_DYN = 'bedrift',
    BETALE_DYN = 'betale',
    BEVEGELSER_DYN = 'bevegelser',
    BIL_DYN = 'bil',
    BOBIL_DYN = 'bobil',
    BONDEGARD_DYN = 'bondegard',
    BUTIKK_DYN = 'butikk',
    BYGGELAN_DYN = 'byggelan',
    CALENDAR_DYN = 'calendar',
    CAMPING_DYN = 'camping',
    CHAT_DYN = 'chat',
    CHECKMARK_TIL_SIRKEL_DYN = 'checkmark-til-sirkel',
    COPY_DYN = 'copy',
    DODSFALL_DYN = 'dodsfall',
    DOKUMENT_DYN = 'dokument',
    E_FAKTURA_DYN = 'e-faktura',
    E_FAKTURA_LOGO_DYN = 'e-faktura-logo',
    EKSTERN_DYN = 'ekstern',
    FACEBOOK_24 = 'facebook-24',
    FACEBOOK_36 = 'facebook-36',
    FACEBOOK_DYN = 'facebook',
    FAKTURA_DYN = 'faktura',
    FAMILIE_DYN = 'familie',
    FORDELER_DYN = 'fordeler',
    FORSIKRINGSBEVIS_REISE_DYN = 'forsikringsbevis-reise',
    GAVE_DYN = 'gave',
    GRAFLINJE_DYN = 'graflinje',
    GRAVEMASKIN_DYN = 'gravemaskin',
    GRUPPE_DYN = 'gruppe',
    HANDLEKURV_DYN = 'handlekurv',
    HANDTRYKK_DYN = 'handtrykk',
    HANDTVERKER_BIL_DYN = 'handtverker-bil',
    HANDVERKER_DYN = 'handverker',
    HELSE_DYN = 'helse',
    HENGELAS_APEN_DYN = 'hengelas-apen',
    HEST_DYN = 'hest',
    HONE_DYN = 'hone',
    HUND_DYN = 'hund',
    HUS_DYN = 'hus',
    HYTTE_DYN = 'hytte',
    INBOX_DYN = 'inbox',
    INFO_DYN = 'info',
    INNBOFORSIKRING_DYN = 'innboforsikring',
    INNFRI_KREDITTKORT_DYN = 'innfri-kredittkort',
    INNSTILLINGER_DYN = 'innstillinger',
    INNTEKT_DYN = 'inntekt',
    INSTAGRAM_24 = 'instagram-24',
    INSTAGRAM_36 = 'instagram-36',
    INSTAGRAM_DYN = 'instagram',
    JORDEN_DYN = 'jorden',
    KAKEDIAGRAM_DYN = 'kakediagram',
    KALENDER_DYN = 'kalender',
    KALKULATOR_DYN = 'kalkulator',
    KAMERA_DYN = 'kamera',
    KART_DYN = 'kart',
    KJORETOY_DYN = 'kjoretoy',
    KLOKKE_DYN = 'klokke',
    KONTOER_DYN = 'kontoer',
    KONTOR_DYN = 'kontor',
    KREDITTGRENSE_DYN = 'kredittgrense',
    KRYSS_DYN = 'kryss',
    KU_DYN = 'ku',
    LAN_DYN = 'lan',
    LASTEBIL_DYN = 'lastebil',
    LEGE_DYN = 'lege',
    LINKEDIN_24 = 'linkedin-24',
    LINKEDIN_36 = 'linkedin-36',
    LINKEDIN_DYN = 'linkedin',
    LOMMEBOK_DYN = 'lommebok',
    LYSPAERE_DYN = 'lyspaere',
    MAIL_DYN = 'mail',
    MASTERCARD_DYN = 'mastercard',
    MEDALJE_DYN = 'medalje',
    MER_DYN = 'mer',
    MINUS_DYN = 'minus',
    MOBIL_DYN = 'mobil',
    MOBILBANK_DYN = 'mobilbank',
    MOPED_DYN = 'moped',
    MOTORSYKKEL_DYN = 'motorsykkel',
    NEDLASTING_DYN = 'nedlasting',
    NETTBANK_DYN = 'nettbank',
    NOKKEL_DYN = 'nokkel',
    NYHETER_DYN = 'nyheter',
    OVERFOERE_DYN = 'overfoere',
    OYE_DYN = 'oye',
    PARAPLY_DYN = 'paraply',
    PENGESEKK_DYN = 'pengesekk',
    PENN_DYN = 'penn',
    PERSONER_DYN = 'personer',
    PIN_KODE_DYN = 'pin-kode',
    PLANTE_DYN = 'plante',
    PLASTER_DYN = 'plaster',
    PLUSS_DYN = 'pluss',
    PRINT_DYN = 'print',
    PROFIL_DYN = 'profil',
    RADGIVER_DYN = 'radgiver',
    RADGIVING_DYN = 'radgiving',
    REFINANSIERING_DYN = 'refinansiering',
    REGIONSPERRE_DYN = 'regionsperre',
    RENTER_DYN = 'renter',
    RESIRKULER_DYN = 'resirkuler',
    SIGNATUR_DYN = 'signatur',
    SIKKERHET_DYN = 'sikkerhet',
    SKADE_DYN = 'skade',
    SLETT_DYN = 'slett',
    SNAPCASH_DYN = 'snapcash',
    SNAPCHAT_24 = 'snapchat-24',
    SNAPCHAT_36 = 'snapchat-36',
    SNAPCHAT_DYN = 'snapchat',
    SNOSCOOTER_DYN = 'snoscooter',
    SOEK_DYN = 'soek',
    SPAREGRIS_DYN = 'sparegris',
    SPARING_DYN = 'sparing',
    SPERR_KORT_DYN = 'sperr-kort',
    STJERNE_DYN = 'stjerne',
    STOPP_DYN = 'stopp',
    TANNHJUL_DYN = 'tannhjul',
    TAXI_DYN = 'taxi',
    TELEFON_DYN = 'telefon',
    TILHENGER_DYN = 'tilhenger',
    TIMEGLASS_DYN = 'timeglass',
    TRAKTOR_DYN = 'traktor',
    TREKANT_KRYSS_DYN = 'trekant-kryss',
    UFOR_DYN = 'ufor',
    ULYKKE_DYN = 'ulykke',
    UNG_DYN = 'ung',
    USP_CHECKMARK_DYN = 'usp-checkmark',
    UTROPSTEGN_DYN = 'utropstegn',
    VARETRANSPORT_DYN = 'varetransport',
    VARSLER_DYN = 'varsler',
    VEKST_DYN = 'vekst',
    VEKT_DYN = 'vekt',
    VERDI_DYN = 'verdi',
    YOUTUBE_24 = 'youtube-24',
    YOUTUBE_36 = 'youtube-36',
    YOUTUBE_DYN = 'youtube',
    X_24 = 'x-24',
    X_36 = 'x-36',
    X_DYN = 'x',
}

export default IconTypes;
